export default {
    updateWork(state,payload){
        state.work = payload;
    },
    updateCategoriesStructure(state,payload){
        state.categoriesStructure = payload
    }
}